import gsap from "gsap";
import { debounce } from "lodash";

export function init() {
  if (window.innerWidth < 640) {
    handleTabsNavigation(document);
  }
  window.addEventListener(
    "resize",
    debounce(() => {
      // TODO add logic to reset to initial state :/
      // using location reload for now when going from small to big screen
      if (window.innerWidth < 640) {
        handleTabsNavigation(document);
      } else {
        window.location.reload();
      }
    }, 200)
  );

  // Open the right tab on first load
  const currentHash = window.location.hash;
  const currentPathname = window.location.pathname;

  if (currentHash) {
    const currentHashDiv = document.querySelector(`[data-id='${currentHash}']`);
    if (currentHashDiv instanceof HTMLElement) {
      currentHashDiv.style.display = "block";
    }
    const currentTab = document.querySelector(`a[href='${currentHash}']`);
    if (currentTab instanceof HTMLElement) {
      currentTab.classList.add("active");
    }
  } else {
    if (currentPathname === "/account") {
      const overviewDiv = document.querySelector(`[data-id='#overview']`);
      if (overviewDiv instanceof HTMLElement) {
        overviewDiv.style.display = "block";
      }
      const overviewTab = document.querySelector(`a[href='#overview']`);
      if (overviewTab instanceof HTMLElement) {
        overviewTab.classList.add("active");
      }
    } else if (currentPathname.includes("/account/orders")) {
      const currentTab = document.querySelector(`a[href='/account#orders']`);
      if (currentTab instanceof HTMLElement) {
        currentTab.classList.add("active");
      }
    }
  }
  // for mobile (initial nav title when dropdown is closed)
  if (window.innerWidth < 640) {
    const firstTab = document.getElementById("active-tab-name");
    if (!firstTab.innerHTML) {
      /* if (currentHash.includes("information")) {
        firstTab.innerHTML = "Account information";
      } else  */

      if (window.location.href.includes("orders")) {
        firstTab.innerHTML = "Orders";
      } else {
        firstTab.innerHTML = "Account overview";
      }
    }
  }

  // Tabs may have links or hashes
  /*   const samePageLinks = Array.from(
    document.querySelectorAll(".account-tabs-container a[href^='#']")
  );
  for (let link of samePageLinks) {
    link.addEventListener("click", (e) => {
      console.log("click");
    });
  } */
  window.addEventListener("hashchange", (e) => {
    let newUrl = e.newURL;
    let oldUrl = e.oldURL;
    let oldHash =
      oldUrl.indexOf("#") > 0
        ? oldUrl.substring(oldUrl.indexOf("#"))
        : "#overview";

    let newHash = newUrl.substring(newUrl.indexOf("#")); //#example
    handleHashChange(oldHash, newHash);
  });
}

function handleHashChange(oldHash, newHash) {
  let oldTabContent = document.querySelector(`div[data-id="${oldHash}"]`);
  let oldTabName = document.querySelector(
    `.account-tab > a[href="${oldHash}"]`
  );
  oldTabName.classList.remove("active");
  oldTabContent.style.display = "none";

  let newTabContent = document.querySelector(`div[data-id="${newHash}"]`);
  let newTabName = document.querySelector(
    `.account-tab > a[href="${newHash}"]`
  );
  newTabName.classList.add("active");
  newTabContent.style.display = "block";

  // for mobile (nav title when dropdown is closed)
  const activeTabName = document.getElementById("active-tab-name");
  activeTabName.innerHTML = /* html */ `${newTabName.dataset.tabName}`;
}

function handleTabsNavigation(baseElement) {
  let tabsOpen = false;

  const firstTab = baseElement.querySelector(".account-tab--first");
  const tabsContainer = baseElement.querySelector(".account-tabs-container");

  const samePageLinks = Array.from(
    document.querySelectorAll(".account-tabs-container a[href^='#']")
  );
  firstTab.addEventListener("click", () => {
    if (!tabsOpen) {
      firstTab.style.display = "none";

      gsap.to(tabsContainer, {
        height: "auto",
        duration: "0.1",
        ease: "expo",
        onComplete: function() {
          tabsOpen = true;
        },
      });
    }
  });
  // Close tabs when click link
  for (let link of samePageLinks) {
    link.addEventListener("click", (e) => {
      gsap.to(tabsContainer, {
        height: "40px",
        duration: "0.1",
        ease: "expo",
        onComplete: function() {
          tabsOpen = false;
          firstTab.style.display = "grid";
        },
      });
    });
  }
}
